import { api } from "./index";

export function getProductVariants(shipInsureId) {
  return api.get("/webapp/order_lookup/product_variants", {
    params: {
      ship_insure_id: shipInsureId,
    },
  });
}
